import React, { useState } from "react";
import BreadCrumb from "../../../Common/BreadCrumb";
import SideChat from "./SideChat";
import MainChat from "./MainChat";

const ChatPage = () => {

  const [selectedChat, setSelectedChat] = useState(false)

  const toggleChat = (e: boolean) => {
    setSelectedChat(!selectedChat)
  }

  return (
    <React.Fragment>
      <BreadCrumb title="Chat" pageType="Apps" />

      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div
          className="relative flex flex-row items-start gap-4"
          x-data="{selectedchat: false}"
        >
          {/* side */}
          <SideChat toggleChat={toggleChat} />
          {/* main */}
          <MainChat selectedChat={selectedChat} toggleChat={toggleChat} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ChatPage;
